import {
  Button,
  Modal,
  Form,
  Input,
  Image,
  Upload,
  InputNumber
} from 'antd';

import {
  useRef,
  useState,
  forwardRef,
  useImperativeHandle
} from 'react';

import { useTranslation } from "react-i18next";

import {
  UploadOutlined
} from '@ant-design/icons';

import './printTemplateThree.css';

import useModal from '../../../../hooks/useModal';

import {
  readBlobAsDataURL
} from '../../../../utils';

interface PrintTemplateThreeProps {
  resultData: any,
  chatData: any,
  outerBorder?: boolean
  innerBorder?: boolean
}

const PrintTemplateThree = ({
  resultData = {},
  chatData = {},
  outerBorder = false,
  innerBorder = false
}: PrintTemplateThreeProps, ref: any) => {
  const { t } = useTranslation();
  const {
    okText,
    cancelText
  } = useModal();

  const paperRefs = useRef<any>([]);

  const [editVisible, setEditVisible] = useState(false);

  const [editParams, setEditParams] = useState<any>({
    name: '',
    value: ''
  });

  const [dataList, setDataList] = useState<any>([])

  const [headerConfig, setHeaderConfig] = useState({
    logo: '',
    textOne: '',
    textTwo: ''
  });

  const [footerConfig, setFooterConfig] = useState({
    hrefWebsite: ''
  });

  const getRef = (el: any, index: number) => {
    paperRefs.current[index] = el;
  }

  const [editType, setEditType] = useState('');
  const [editField, setEditField] = useState('');
  const [editIndex, setEditIndex] = useState(-1);
  const [editCIndex, setEditCIndex] = useState(-1);

  const handleEditField = (type: string, data: any, field: string, index: number, cIndex?: number) => {
    if (data) {
      let param: { name?: string, value?: string } = {};

      if (data.hasOwnProperty('key')) {
        param['name'] = data.key;
      }

      if (data.hasOwnProperty('value')) {
        param['value'] = data.value;
      }

      if (field) {
        param['value'] = data[field];
      }

      setEditParams(param);
    }

    setEditType(type);
    setEditIndex(index);
    setEditField(field);
    setEditCIndex(cIndex !== undefined ? cIndex : -1);
    setEditVisible(true);
  }

  const [editImgType, setEditImgType] = useState('');
  const [editImgField, setEditImgField] = useState('');
  const [editImgIndex, setEditImgIndex] = useState(-1);
  const [editImgCIndex, setEditImgCIndex] = useState(-1);
  const [editImgPreview, setEditImgPreview] = useState('');
  const [editImgVisible, setEditImgVisible] = useState(false);

  const handleEditFile = (type: string, data: any, field: string, index: number, cIndex?: number) => {
    setEditImgType(type);
    setEditImgPreview(data);
    setEditImgIndex(index);
    setEditImgField(field);
    setEditImgCIndex(cIndex !== undefined ? cIndex : -1);
    setEditImgVisible(true);
  }

  const beforeUploadPreview = (file: any) => {
    readBlobAsDataURL(file, (res: any) => {
      setEditImgPreview(res);
    });
  }

  const handleEditImgConfirm = () => {
    if (editImgType === 'one-head') {
      // setOneImgData(editImgPreview);
    } else if (editImgType === 'two-content') {
      let list: any = twoContentData || [];
      let listItem = list[editImgIndex];

      if (editCIndex !== -1) {
        listItem.children[editImgCIndex].value = editImgPreview;
      }

      setTwoContentData(list);
    } else if (editImgType === 'header') {
      let headParam: any = headerConfig;

      if (editImgField) {
        headParam[editImgField] = editImgPreview;
      }

      setHeaderConfig(headParam);
    } else if (editImgType === 'four-img1-data') {
      setFourImgData(editImgPreview);
    }

    setEditImgVisible(false);
  }

  const handleEditConfirm = () => {
    if (editType === 'one-head') {
      let list: any = oneHeadData || [];
      list[editIndex].key = editParams.name;
      list[editIndex].value = editParams.value;

      setOneHeadData(list);
    } else if (editType === 'two-head') {
      let list: any = twoHeadData || [];
      list[editIndex].key = editParams.name;
      list[editIndex].value = editParams.value;

      setTwoHeadData(list);
    } else if (editType === 'two-content') {
      let list: any = twoContentData || [];
      let listItem = list[editIndex];

      if (editCIndex !== -1) {
        listItem.children[editCIndex].key = editParams.name;
        listItem.children[editCIndex].value = editParams.value;
      } else {
        if (editField) {
          listItem[editField] = editParams.value;
        } else {
          listItem.key = editParams.name;
          listItem.value = editParams.value;
        }
      }

      setTwoContentData(list);
    } else if (editType === 'header') {
      let headItem: any = headerConfig;
      headItem[editField] = editParams.value;

      setHeaderConfig(headItem);
    } else if (editType === 'footer') {
      let footerItem: any = footerConfig;
      footerItem[editField] = editParams.value;

      setHeaderConfig(footerItem);
    }

    setEditVisible(false);
  }

  // 排序和筛选 children 数组的方法
  const sortAndFilterChildren = (children: any[], orderArray: string[]) => {
    if (!children || !Array.isArray(children)) return [];

    const filteredChildren = children.filter((item: any) =>
      orderArray.includes(item.key)
    );

    return filteredChildren.sort((a: any, b: any) => {
      const indexA = orderArray.indexOf(a.key);
      const indexB = orderArray.indexOf(b.key);
      return indexA - indexB;
    });
  }

  const getStylePage = (type: string, data?: any) => {
    let pageItem: any = null;

    switch (type) {
      //   case 'style-one':
      // pageItem = pageStyleOne()
      // break;
      case 'style-two':
        pageItem = pageStyleTwo();
        break;
      case 'style-three':
        pageItem = pageStyleThree();
        break;
      case 'style-four':
        pageItem = pageStyleFour();
        break;
      case 'style-images':
        pageItem = pageStyleImages(data);
        break;
      default:
        break;
    }

    return pageItem;
  }

  const handleSortEnter = (num: number, index: number) => {
    let list: Array<any> = [...dataList];

    list = list.sort((a: any, b: any) => {
      return a.sort - b.sort;
    })

    setDataList(list);
  }

  const setDataListSort = (num: number, index: number) => {
    let list: Array<any> = [...dataList];
    list[index].sort = num;

    setDataList(list);
  }

  // 页面数据
  const [oneHeadData, setOneHeadData] = useState([]);
  // const [oneImgData, setOneImgData] = useState('');
  // const [oneDescData, setOneDescData] = useState('');

  const [twoHeadData, setTwoHeadData] = useState([]);
  const [twoContentData, setTwoContentData] = useState([]);

  const [threeImgData, setThreeImgData] = useState('');
  const [threeContentData, setThreeContentData] = useState([]);
  const [threeHeadData] = useState([]);
  const [threeCurveTitle, setThreeCurveTitle] = useState('');

  const [fourImgData, setFourImgData] = useState('');
  const [fourImg2Data, setFourImg2Data] = useState('');
  const [fourContentData, setFourContentData] = useState([]);
  const [fourHtmlData, setFourHtmlData] = useState('');

  // const [imagesData, setImagesData] = useState([])

  // const setStyleOneData = (dataList: any) => {
  //   if (dataList) {
  //     let headList: any = [];

  //     for (const key in dataList) {
  //       if (key === 'cateBImg') {
  //         let img = dataList[key]?.value || '';

  //         setOneImgData(img);
  //       } else if (key === 'cateContent') {
  //         let desc = dataList[key]?.value || '';

  //         setOneDescData(desc);
  //       } else {
  //         headList.push(dataList[key]);
  //       }
  //     }

  //     setOneHeadData(headList);
  //   }
  // }

  const setStyleTwoData = (dataList: any) => {
    const {
      quantity,
      head,
      hmVal,
      effVal,
      npshVal,
      diameterVal,
      rangeEnd,
    } = chatData;

    let fieldItems: any = {
      'dutyFlow': quantity || '',
      'dutyHead': head || '',
      'maxHead': hmVal,
      'efficiencyAtDutyFlow': effVal,
      'availableSystemNPSH': npshVal,
      'dutyPointImpellerDiameter': diameterVal,
      'outletPressure': head || '',
      'NPSHrAtRatedFlow': npshVal,
      'maxAllowanceFlow': rangeEnd
    };

    if (dataList) {
      let headList: any = [];
      let contentList: any = [];

      for (const key in dataList) {
        if (key === 'header') {
          // headList = getListInData(dataList[key]);

          const header = dataList[key];

          const pm = header['pumpModel'].value;
          const finalPm = pm ? pm.split('-')[0] : '';

          headList = [{
            key: '',
            value: ''
          }, {
            key: 'Customer Item No',
            value: header['customerItemNo'].value
          }, {
            key: 'Pump model',
            value: finalPm
          }, {
            key: 'Inquiry Date',
            value: header['inquiryDate'].value
          }]
        } else {
          let childItem = dataList[key];

          let items: any = {};
          if (childItem) {
            for (const cKey in childItem) {
              let citem = childItem[cKey] || {};

              if (fieldItems[cKey] !== undefined) {
                citem['value'] = fieldItems[cKey];
              }

              if (cKey !== 'title') {
                items[cKey] = childItem[cKey];
              }
            }
          }

          let dataObj = {
            title: childItem['title']?.key || '',
            children: getListInData(items)
          };

          contentList.push(dataObj);
        }
      }

      const pumpParams = [
        "Model",
        "Pump standaed",
        "Impeller type",
        "Inlet DN",
        "Outlet DN",
        "Rated speed",
        "Duty Flow(m³/h)",
        "Duty Head(m)",
        "Shaft Power(KW)",
        "Effiency at duty flow(%)",
        "NPSHr at rated flow(m)",
        "Duty point impeller diameter(mm)",
        "Max allowance flow(m³/h)",
        "Shut-off head(m)",
        "Max impeller diameter(mm)",
        "Min impeller diameter(mm)"
      ];

      const motorParams = [
        "Phase",
        "Motor Model",
        "Efficiency Class",
        "Rated Power(KW)",
        "Rated speed",
        "Frequency(HZ)",
        "Rated voltage(V)",
        "Rated current(A)",
        "Motor eff(%)",
        "Power factor(cos φ)",
        "Tmax/TN",
        "Noise(dB)",
        "Power/pole/current",
        "Vibration(mm/s)",
        "Motor weigh",
        "Tst/TN",
        "RT(N*M)",
        "Ist/IN"
      ];

      const pumpMaterials = [
        "Casing",
        "Impeller",
        "Shaft",
        "Shaft seal",
        "Shaft sleeve",
        "Wear ring",
        "Bearing"
      ];

      const designData = [
        "Scope of supply Pump",
        "Pump standard",
        "Shaft axis position",
        "Pump design",
        "Impeller type",
        "Pump system design",
        "Specification of wetted parts",
        "Pump direction of rotation, viewed from drive end"
      ];

      contentList.forEach((v: any) => {
        const {
          title,
          children
        } = v || {};

        if (title.indexOf("Pump Data") > -1) {
          v.title = "Pump Data(operating)";

          if (children && Array.isArray(children)) {
            v.children = sortAndFilterChildren(children, pumpParams);
          }
        }

        if (title.indexOf("Motor Data") > -1) {
          v.title = "Motor";

          if (children && Array.isArray(children)) {
            v.children = sortAndFilterChildren(children, motorParams);
          }
        }

        if (title.indexOf("Pump Main Materials") > -1) {
          if (children && Array.isArray(children)) {
            v.children = sortAndFilterChildren(children, pumpMaterials);
          }
        }

        if (title.indexOf("Design data pump") > -1) {
          if (children && Array.isArray(children)) {
            v.children = sortAndFilterChildren(children, designData);
          }
        }
      });

      setTwoHeadData(headList);
      setTwoContentData(contentList);
    }
  }

  const setStyleThreeData = (data: any) => {
    const {
      quantity,
      head,
      hmVal,
      effVal,
      powerVal,
      frequencyVal,
      speedVal,
      rangeStr,
      chatBase64Data
    } = chatData;

    let fieldItems: any = {
      'ratedFlow': quantity || '',
      'headAtRated': head || '',
      'HMax': hmVal,
      'efficiencyAtRatedFlow': effVal,
      'shaftPowerAtRatedFlow': powerVal,
      'frequency': frequencyVal,
      'operationSpeed': speedVal,
      'allowanceCapacityRange': rangeStr,
    };

    let contentList: any = [];

    if (data) {
      for (const key in data) {
        let item = data[key] || {};

        if (key === 'curveDataBasedOn') {

        } else {
          if (fieldItems[key] !== undefined) {
            item['value'] = fieldItems[key];
          }

          if (key === 'performanceCurve') {
            setThreeCurveTitle(item.key || '');
          } else {
            if (item['key'] === 'Performance acceptance acc to') {
              item['key'] = 'Performance acceptance ISO09906 Gland 2';
            }
            
            contentList.push(item);
          }
        }
      }
    }

    setThreeContentData(contentList);

    if (chatBase64Data) {
      setThreeImgData(chatBase64Data);
    }
  }

  const setStyleFourData = (data: any) => {
    if (!data) {
      return;
    }

    const {
      sizeDataType,
      sizeImage,
      sizeData,
      installSizeImage
    } = data;

    setFourImgData(sizeImage || '');
    setFourImg2Data(installSizeImage || '');

    if (sizeDataType === 1) {
      setFourHtmlData(sizeData);
      setFourContentData([]);
    } else {
      let tableData = sizeData.map((td: any) => {
        return {
          key: td.name,
          value: td.value
        }
      }) || [];

      setFourHtmlData('');
      setFourContentData(tableData);
    }
  }

  // 获取对象数据进行for in 组装成数组返回
  const getListInData = (dataObj: any) => {
    let list: any = [];

    for (const key in dataObj) {
      list.push(dataObj[key]);
    }

    return list;
  }

  const handleImageError = (type: string) => {
    switch (type) {
      case 'one-head':
        // setOneImgData('');
        break;
      case 'three-img-data':
        setThreeImgData('');
        break;
      case 'four-img1-data':
        setFourImgData('');
        break;
      case 'four-img2-data':
        setFourImg2Data('');
        break;
    }
  }

  //   const pageStyleOne = () => {
  //     return (
  //       <div className={`page-style-one ${outerBorder ? 'page-border' : ''}`}>
  //         <div className="item-one-data">
  //           {
  //             oneHeadData.map((item: any, index: number) => (
  //               <div 
  //                 className={`cursor-item ${innerBorder ? 'style-item-border' : ''}`} 
  //                 onClick={() => handleEditField('one-head', item, '', index)}
  //               >
  //                 <p className="text-desc">
  //                   {item.key}
  //                 </p>
  //                 {
  //                   item.value ? (<p className="text-value">{ item.value }</p>) : null
  //                 }
  //               </div>
  //             ))
  //           }
  //         </div>
  //         {
  //           oneImgData ? <img
  //             alt=""
  //             className="data-img cursor-item" 
  //             src={oneImgData}
  //             onClick={() => handleEditFile('one-head', oneImgData, 'oneImgData', -1)}
  //             onLoad={() => {console.log('oneImgData load finish')}}
  //             onError={() => handleImageError('one-head')}
  //           /> : null
  //         }
  //         <div className="item-one-data">
  //           <p className="text-value text-value-line40" dangerouslySetInnerHTML={{ __html: oneDescData }}></p>
  //         </div>
  //       </div>
  //     )
  //   }

  const pageStyleTwo = () => {
    return (
      <div className={`page-style-two ${outerBorder ? 'page-border' : ''}`}>
        <div className="style-head-title">
          Technical Datasheet
        </div>
        <div className="style-head">
          {
            twoHeadData.map((item: any, index: number) => {
              const {
                key,
                value
              } = item;

              if (key === '') {
                return (
                  <div
                    key={`psth-${index}`}
                  />
                )
              }

              return (
                <div
                  key={`psth-${index}`}
                  className={`cursor-item ${innerBorder ? 'style-item-border' : ''}`}
                  onClick={() => handleEditField('two-head', item, '', index)}
                >
                  <p className="text-desc">{key}:</p>
                  <p className="text-value">{value}</p>
                </div>
              );
            })
          }
        </div>
        <div className="style-content">
          {
            twoContentData.map((item: any, index: number) => (
              <div
                key={`pstc-${index}`}
              >
                <div
                  className="text-title cursor-item"
                  onClick={() => handleEditField('two-content', item, 'title', index)}
                >
                  {item.title}
                </div>
                {
                  item.children.map((child: any, cIndex: number) => {
                    if (child.type === 'img') {
                      return (
                        // 565 * 376
                        <div
                          key={`psti-${index}-${cIndex}`}
                        >
                          <div
                            className={`style-item-img cursor-item ${innerBorder ? 'style-item-border' : ''}`}
                            style={{ backgroundImage: `url(${child.value})` }}
                            onClick={() => handleEditFile('two-content', child.value, '', index, cIndex)}
                          >
                          </div>
                        </div>
                      )
                    } else {
                      return (
                        <div
                          key={`pstn-${index}-${cIndex}`}
                          className={`style-item cursor-item ${innerBorder ? 'style-item-border' : ''}`}
                          onClick={() => handleEditField('two-content', child, '', index, cIndex)}
                        >
                          <p className="text-desc">{child.key}</p>
                          <p className="text-value">{child.value}</p>
                        </div>
                      )
                    }
                  })
                }
              </div>
            ))
          }
        </div>
      </div>
    );
  }

  const pageStyleThree = () => {
    return (
      <div className={`page-style-three ${outerBorder ? 'page-border' : ''}`}>
        <div className="style-head-title">
          Technical Datasheet
        </div>
        <div className="style-head">
          {
            threeHeadData.map((item: any, index: number) => {
              return (
                <div key={`psrh-${index}`}>
                  <p className="text-desc">{item.key}</p>
                  <p className="text-value">{item.value}</p>
                </div>
              )
            })
          }
        </div>
        <div className='cover-title'>{threeCurveTitle}</div>
        {
          threeImgData ? <img alt="" className="style-img" src={threeImgData} onError={() => handleImageError('three-img-data')} /> : null
        }
        <div className="style-content">
          {
            threeContentData.map((item: any, index: number) => {
              const {
                key,
                value
              } = item;

              let finalValue = value;

              if (key === 'Model') {
                finalValue = value.split('-')[0];
              }

              return (
                <div
                  key={`psrc-${index}`}
                  className={`${innerBorder ? 'style-item-border' : ''}`}
                >
                  <p className="text-desc">{key}</p>
                  <p className="text-value">{finalValue}</p>
                </div>
              )
            })
          }
        </div>
      </div>
    );
  }

  const pageStyleFour = () => {
    return (
      <div className={`page-style-four ${outerBorder ? 'page-border' : ''}`}>
        <div className="style-head-title">
          Technical Datasheet
        </div>
        <div
          className='img-wrap cursor-item'
          onClick={() => handleEditFile('four-img1-data', fourImgData, 'fourImgData', -1)}
        >
          {
            fourImgData ?
              <img alt="" className="style-img" src={fourImgData} onError={() => handleImageError('four-img1-data')} /> :
              <UploadOutlined className='upload-icon' />
          }
        </div>
        {
          fourHtmlData ? (
            <div className="html-table" dangerouslySetInnerHTML={{ __html: fourHtmlData }}></div>
          ) : (
            <div className="style-table">
              {
                fourContentData.map((item: any, index: number) => (
                  <div
                    key={`psfc-${index}`}
                    className="table-item"
                  >
                    <div className="table-item-th">{item.key}</div>
                    <div className="table-item-td">{item.value}</div>
                  </div>
                ))
              }
            </div>
          )
        }
        {
          fourImg2Data ? <img alt="" className="style-img2" src={fourImg2Data} onError={() => handleImageError('four-img2-data')} /> : null
        }
      </div>
    );
  }

  const pageStyleImages = (data: any) => {
    let imagesData = data

    return (
      <div className={`page-style-images ${outerBorder ? 'page-border' : ''}`}>
        <div className="style-head-title">
          Technical Datasheet
        </div>
        <p className='style-img-desc'>{imagesData.text}</p>
        <div>
          {
            imagesData && imagesData.image
              ? <img className="style-img" src={imagesData.image} onError={() => handleImageError('image-data')} alt="" />
              : null
          }
        </div>
      </div>
    );
  }

  const getFileName = () => {
    let modelItem: any = oneHeadData.find((item: any) => item.key === 'Model');

    if (modelItem) {
      return modelItem.value;
    }

    return null;
  }

  const initData = (printData: any) => {
    const {
      content,
      header,
      footer,
    } = printData;

    if (header) {
      let headerItem = {
        logo: header.logo || '',
        textOne: header.text.one || '',
        textTwo: header.text.two || ''
      };

      setHeaderConfig(headerItem);
    }

    if (footer) {
      let fooetrItem = {
        hrefWebsite: footer.href.website
      };

      setFooterConfig(fooetrItem);
    }

    if (content) {
      let pageData: any = [];
      let pageStyleObj: any = {
        pageOne: 'style-one',
        pageTwo: 'style-two',
        pageThree: 'style-three',
        pageFour: 'style-four',
        pictureList: 'style-images'
      };

      let index = 0;

      const filterKeys = ['pageOne', 'pageTwo', 'pageThree', 'pictureList'];

      for (let i in filterKeys) {
        const key = filterKeys[i];

        if (key === 'pictureList') {
          if (content[key]) {
            const imgList: any = content[key] || [];

            // eslint-disable-next-line no-loop-func
            imgList.forEach((item: any) => {
              index += 1;

              pageData.push({
                sort: index,
                type: pageStyleObj[key],
                data: item
              });
            });
          }
        } else {
          if (key !== 'pageOne') {
            index += 1;

            pageData.push({
              sort: index,
              type: pageStyleObj[key] || '',
              data: content[key]
            });
  
            if (key === 'pageTwo') {
              setStyleTwoData(content[key]);
            } else if (key === 'pageThree') {
              setStyleThreeData(content[key]);
            } else if (key === 'pageFour') {
              setStyleFourData(content[key]);
            }
          }
        }
      }

      setDataList(pageData);
    }
  }

  const setData = (data: any) => {
    if (data) {
      initData(data);
    }
  }

  useImperativeHandle(ref, () => ({
    pageRefs: paperRefs.current,
    getFileName,
    setData
  }));

  // useEffect(() => {
  //   if (resultData) {
  //     initData()
  //   }
  // }, [resultData])

  return (
    <div className='page-template-three'>
      {
        dataList.map((refItem: any, refIndex: number) => {
          const {
            type
          } = refItem || {};

          if (type === 'style-one') {
            return null;
          }

          return (
            <div
              key={`ptt-${refIndex}`}
              className="pages-item"
            >
              <div className="pages-item-number">
                {t("exPdf.sortNumber")}：
                <InputNumber
                  min={1}
                  step={1}
                  value={refItem.sort}
                  onChange={(num: any) => setDataListSort(num, refIndex)}
                  onBlur={(e: any) => handleSortEnter(e, refIndex)}
                  onStep={(e: any) => handleSortEnter(e, refIndex)}
                />
              </div>
              <div
                className={`pages-content pages-content-${refItem.type}`}
                key={refIndex}
                id={'pages-content-' + refIndex}
                ref={(e: any) => getRef(e, refIndex)}
              >
                <div className="paper-header">
                  <div
                    className="cursor-item"
                    onClick={() => handleEditFile('header', headerConfig.logo, 'logo', 0)}
                  >
                    <img
                      alt=""
                      className="left-icon"
                      src={headerConfig.logo}
                    />
                  </div>
                  <div className="header-right">
                    <h3
                      className="right-title cursor-item"
                      onClick={() => handleEditField('header', headerConfig, 'textOne', 0)}
                    >
                      {headerConfig.textOne}
                    </h3>
                    <p
                      className="right-desc cursor-item"
                      onClick={() => handleEditField('header', headerConfig, 'textTwo', 0)}
                    >
                      {headerConfig.textTwo}
                    </p>
                  </div>
                </div>
                {
                  getStylePage(refItem.type, refItem.data)
                }
                <div className="paper-footer">
                  <div></div>
                  <div>{refIndex + 1}</div>
                  <div
                    className="cursor-item"
                    onClick={() => handleEditField('footer', footerConfig, 'hrefWebsite', 0)}
                  >
                    {footerConfig.hrefWebsite}
                  </div>
                </div>
              </div>
            </div>
          )
        })
      }

      <Modal
        open={editVisible}
        title={t("exPdf.editFieldTitle")}
        okText={okText}
        cancelText={cancelText}
        width={'400px'}
        mask={false}
        centered
        onCancel={() => setEditVisible(false)}
        onOk={handleEditConfirm}
      >
        <div>
          <Form layout="vertical">
            {
              editParams.name !== undefined ? (
                <Form.Item label={t("exPdf.editFieldLabel")}>
                  <Input
                    placeholder={t("exPdf.editFieldLabelPlac")}
                    value={editParams.name}
                    onChange={(e) => setEditParams({ ...editParams, name: e.target.value })}
                  />
                </Form.Item>
              ) : null
            }
            <Form.Item label={t("exPdf.editFieldValue")}>
              <Input
                placeholder={t("exPdf.editFieldLabelPlac")}
                value={editParams.value}
                onChange={(e) => setEditParams({ ...editParams, value: e.target.value })}
              />
            </Form.Item>
          </Form>
        </div>
      </Modal>
      <Modal
        open={editImgVisible}
        title={t("exPdf.editImgTitle")}
        okText={okText}
        cancelText={cancelText}
        width={'400px'}
        mask={false}
        centered
        onCancel={() => setEditImgVisible(false)}
        onOk={handleEditImgConfirm}
      >
        <div>
          <Image
            width={200}
            src={editImgPreview}
          />
          <br />
          <Upload
            beforeUpload={beforeUploadPreview}
            accept="image/*"
            showUploadList={false}
            customRequest={() => { }}
          >
            <Button
              type="primary"
              style={{ marginTop: '10px' }}

            >{t("exPdf.editImgUptext")}</Button>
          </Upload>
        </div>
      </Modal>
    </div>
  );
}

export default forwardRef(PrintTemplateThree);
